export enum BOOKER_TRIP_TYPES {
  ONEWAY = 'OW',
  ROUNDTRIP = 'RT',
  MULTICITY = 'MC',
}
